import React, { useState, useRef } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { Product } from 'public-contracts';
import { ModernProductList } from './ModernProductList';
import { ModernProductForm } from './ModernProductForm';

export const ModernProductManagement: React.FC = () => {
  const { translate } = useTranslation();
  const [formOpen, setFormOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState<Product | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const listRef = useRef<{ refresh: () => void }>(null);

  const handleCreateClick = () => {
    setEditingProduct(null);
    setFormOpen(true);
  };

  const handleEditClick = (product: Product) => {
    setEditingProduct(product);
    setFormOpen(true);
  };

  const handleFormClose = () => {
    setFormOpen(false);
    setEditingProduct(null);
  };

  const handleFormSave = async (product: Product) => {
    console.log('✅ handleFormSave called, closing dialog first');
    setFormOpen(false);
    setEditingProduct(null);

    // Trigger refresh of the product list after a delay to ensure API call completes
    setTimeout(() => {
      setRefreshKey((prev) => {
        console.log(`✅ refreshKey changed from ${prev} to ${prev + 1}`);
        return prev + 1;
      });
    }, 1000);
  };

  return (
    <div className="container mx-auto p-6" data-testid="product-management">
      <ModernProductList
        refreshTrigger={refreshKey}
        onCreateClick={handleCreateClick}
        onEditClick={handleEditClick}
      />

      <ModernProductForm
        open={formOpen}
        onClose={handleFormClose}
        onSave={handleFormSave}
        product={editingProduct}
      />
    </div>
  );
};
